module.exports = __webpack_public_path__ + "static/media/dispenseTheCards_1.78e1c917.mp3";